import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import amazonLogo from "../../assets/images/amazon-logo-1.png";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineRefresh } from "react-icons/hi";
import TextInputLayout from "../../components/compLayouts/textInputLayout";
import { SagaActions } from "../../redux/actionTypes";
import RenderIf from "../../components/renderIf";
import { RootState } from "../../redux/store";

import { statsData } from "./constants/mokData";
import StatsBoxOne from "../../components/statsBox/statsBoxOne";
import {
  getCompanyDetailsByID,
  getCompanyStatsReq,
} from "../../api/company/companyReq";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import {
  createPaymentsReq,
  getPaymentsReq,
} from "../../api/clients/clientsReq";
import SectionContainer from "./components/sectionContainer";
import LastFivePaymentTable from "./components/lastFivePaymentsTable";
import { updateSubscriptionDetailsReq } from "../../api/activation/plansReq";
import { updateCompanyStatusReq } from "../../api/clients/clientsReq";
import { CompanyStatsType } from "../../types/paymentTypes";
import MonthlyDetailsTable from "../../components/tables/monthlyDetailsTable";

type Inputs = {
  amountIs: number;
  dojYY: string;
  dojMM: number;
  dojDD: number;
  txnDetailsIs: string;
};

const ComapnyDetails = (props: { companyData: any }) => {
  // console.log("compony id", props.companyData);
  const Dispatch = useDispatch();
  const { plans } = useSelector((_state: RootState) => _state);
  const [companyDetails, setcompanyDetails] = useState<any>({});
  const [editCompanyDetails, seteditCompanyDetails] = useState(false);
  const [editSubscriptionPlans, seteditSubscriptionPlans] = useState(false);
  const [subscriptionDetails, setsubscriptionDetails] = useState<any>([]);
  const [edminDetails, setedminDetails] = useState<any>([]);
  const [cepDetails, setcepDetails] = useState<any>([]);
  const [paymentDetails, setpaymentDetails] = useState<any>([]);
  const [companyStatusIs, setcompanyStatusIs] = useState("");
  const [visibleSectionIs, setvisibleSectionIs] = useState("");
  const [companyStatsData, setcompanyStatsData] = useState<CompanyStatsType>();

  // E-Admin edit fields
  const [eadminFirstName, seteadminFirstName] = useState("");
  const [eadminLastName, seteadminLastName] = useState("");
  const [eadminEmail, seteadminEmail] = useState("");
  const [eadminPhone, seteadminPhone] = useState("");
  const [eadminPhoneCode, seteadminPhoneCode] = useState(0);
  const [eadminDesignation, seteadminDesignation] = useState("");
  const [eadminActivationLink, seteadminActivationLink] = useState("");

  // plans------------------
  const [planNameIs, setplanNameIs] = useState(0);
  const [planFrequency, setplanFrequency] = useState("");
  const [planCost, setplanCost] = useState("");
  const [planValidity, setplanValidity] = useState("");
  const [selectedPlanDetails, setselectedPlanDetails] = useState({
    subscriptionID: 0,
    subscriptionName: "",
    subscriptionFees: 0,
    subscriptionDuration: "",
  });
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<Inputs>();

  const _planList = plans?.data || [];

  const days = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );
  const months = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );
  const years = Array.from({ length: 2 }, (_, i) => 2024 - i);

  const fetchCompanyDataById = async () => {
    try {
      const res = await getCompanyDetailsByID({
        companyID: props?.companyData?.companyID,
      });
      // toast.success(res?.message);
      const _companyData = {
        companyWebLogoURL: res?.data?.companyWebLogoURL,
        CompanyName: res?.data?.CompanyName,
        createdAt: res?.data?.createdAt,
        Status: res?.data?.Status,
        subscriptionValidUpto: res?.data?.subscriptionValidUpto,
      };
      const _subscriptionData = res?.data?.subscription;
      const _edminData = res?.data?.EAdmin;
      const _cepData = res?.data?.CEPPartnerDetails;
      setcompanyStatusIs(res?.data?.Status);
      setsubscriptionDetails(_subscriptionData);
      setedminDetails(_edminData);
      setcepDetails(_cepData);
      setcompanyDetails(_companyData);

      // Initialize E-Admin edit fields with current data
      if (_edminData && _edminData.length > 0) {
        const eadmin = _edminData[0];
        seteadminFirstName(eadmin?.firstName || "");
        seteadminLastName(eadmin?.lastName || "");
        seteadminEmail(eadmin?.email || "");
        seteadminPhone(eadmin?.mobileNumber || "");
        seteadminPhoneCode(eadmin?.PhoneCountryCode || 0);
        seteadminDesignation(eadmin?.designation || "");
        seteadminActivationLink(eadmin?.activationLink || "");
      }
    } catch (error: any) {
      toast.error(error?.errMessage);
    }
  };

  const fetchCompanyStatsDataById = async () => {
    try {
      const res = await getCompanyStatsReq({
        companyID: props?.companyData?.companyID,
      });
      // toast.success(res?.message);
      setcompanyStatsData(res?.data);
    } catch (error: any) {
      toast.error(error?.errMessage);
    }
  };

  const createPayment = async (data: Inputs) => {
    try {
      const _data = {
        companyID: props.companyData.companyID,
        amount: Number(data?.amountIs),
        // receivedDate: `${data?.dojYY}-${data?.dojMM}-${data?.dojDD}`,
        receivedDate: data?.dojYY,
        txnDetails: data?.txnDetailsIs,
      };
      // return;
      const res = await createPaymentsReq(_data);
      toast.success(res?.message);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "comapnyDetails",
          methodName: "createPayment",
          type: "info",
        },
      });
      reset();
    } catch (error: any) {
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "comapnyDetails",
          methodName: "createPayment",
          type: "error",
        },
      });
    }
  };

  const getPayments = async () => {
    try {
      // const companyId = props?.companyData?.companyID;
      const res = await getPaymentsReq({
        companyID: props?.companyData?.companyID,
      });
      // const paymentsData = {
      //   amount: res?.data?.amount,
      //   receivedDate: res?.data?.receivedDate,
      // };
      setpaymentDetails(res.data);
    } catch (error) { }
  };

  const updateCompanyDetails = async () => {
    try {
      const updatePayload: any = {
        Status: companyStatusIs,
      };

      // Add E-Admin fields if they were edited
      if (eadminFirstName || eadminLastName || eadminEmail || eadminPhone || eadminDesignation) {
        if (eadminFirstName) updatePayload.firstName = eadminFirstName;
        if (eadminLastName) updatePayload.lastName = eadminLastName;
        if (eadminEmail) updatePayload.email = eadminEmail;
        if (eadminPhone) updatePayload.mobileNumber = eadminPhone;
        if (eadminPhoneCode) updatePayload.PhoneCountryCode = eadminPhoneCode;
        if (eadminDesignation) updatePayload.designation = eadminDesignation;
      }

      const res = await updateCompanyStatusReq(
        { companyID: props?.companyData?.companyID },
        updatePayload
      );
      toast.success(res?.message);
      seteditCompanyDetails(false);
      getNewClientDetails();
    } catch (error) { }
  };
  const updateSubscriptionPlans = async () => {
    try {
      console.log(planNameIs, planFrequency, planCost, planValidity, "");
      const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const month = date.toLocaleString("en-US", { month: "short" });
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day} ${year}`;
      };
      // const subscriptionID = planNameIs === 0 ? companyDetails?.
      const res = await updateSubscriptionDetailsReq(
        { companyID: props?.companyData?.companyID },
        {
          subscriptionID: planNameIs
            ? planNameIs
            : subscriptionDetails?.[0]?.subscriptionID,
          subscriptionValidUpto: formatDate(planValidity),
        }
      );
      toast.success(res?.message);

      seteditSubscriptionPlans(false);
      getNewClientDetails();
    } catch (error) { }
  };
  const getNewClientDetails = () => {
    fetchCompanyDataById();
    fetchCompanyStatsDataById();
    getPayments();
  };

  const _companyWebLogoURL = companyDetails?.companyWebLogoURL;
  const _companyName = companyDetails?.CompanyName;
  const _companyStatus = companyDetails?.Status;
  const _createdAt = companyDetails?.createdAt;
  const _subscriptionValidUpto = companyDetails?.subscriptionValidUpto;

  useEffect(() => {
    if (!props?.companyData.companyID) return;
    getNewClientDetails();
  }, [props?.companyData.companyID]);

  useEffect(() => {
    Dispatch({ type: SagaActions.GET_PLANS });
  }, []);

  // useEffect(() => {
  //   if (_planList?.length > 0)
  //     setplanValidity(_planList[0].subscriptionDuration);
  // }, [_planList]);

  // console.log("companyStatsData",companyStatsData);

  return (
    <ComapnyDetailsWarpper className="p-2">
      <div className="d-flex align-items-center justify-content-between pt-2 px-2">
        <div className="logo_box ">
          {!!_companyWebLogoURL && <img src={_companyWebLogoURL} />}
        </div>

        <p className="sm-text">
          <span className="text-secondary">Account created on </span>
          <span>
            <b className="">
              {!dayjs(_createdAt).isValid()
                ? "NA"
                : dayjs(_createdAt).format("MMM DD, YYYY")}
            </b>
          </span>
        </p>
      </div>

      <div className="d-flex align-items-center justify-content-end px-2">
        <RenderIf isShow={!editCompanyDetails}>
          <button
            className="border-0 bg-white text-primary"
            onClick={() => seteditCompanyDetails(true)}
          >
            <MdOutlineModeEditOutline className={`me-2 primary-color`} />
            <span className="me-2 p-1 primary-color">Edit</span>{" "}
          </button>
        </RenderIf>
        <RenderIf isShow={!!editCompanyDetails}>
          {/* <button
            className="border border-primary rounded bg-white text-primary "
            onClick={() => updateCompanyDetails()}
          >
            <span className="me-2 p-1">Update</span>{" "}
          </button> */}
          <div className=" col-lg-2 col-md-4 d-flex flex-column justify-content-end p-2">
            <button
              // type="submit"
              onClick={() => updateCompanyDetails()}
              className="btn btn-sm primary-bg text-white w-100"
            >
              Update
            </button>
          </div>
        </RenderIf>
        <RenderIf isShow={!!editCompanyDetails}>
          {/* <button
            className="secondary-border rounded bg-white secondary-color ms-2 "
            onClick={() => seteditCompanyDetails(false)}
          >
            <span className="me-2 p-1">Cancel</span>{" "}
          </button> */}
          <div className=" col-lg-2 col-md-4 d-flex flex-column justify-content-end p-2">
            <button
              type="submit"
              onClick={() => seteditCompanyDetails(false)}
              className="btn btn-sm primary-bg text-white w-100"
            >
              Cancel
            </button>
          </div>
        </RenderIf>
      </div>
      <div className="px-2">
        <RenderIf isShow={!editCompanyDetails}>
          <p className="sm-text">
            Status:
            <b
              style={{
                color:
                  _companyStatus === "Inactive" || _companyStatus === "Paused"
                    ? "red"
                    : "#198754",
              }}
            >
              {" "}
              {_companyStatus}{" "}
            </b>
          </p>
        </RenderIf>
        <RenderIf isShow={!!editCompanyDetails}>
          <p className="sm-text">
            Status:
            <select
              value={companyStatusIs}
              className="px-2 rounded border mx-2 m-1"
              onChange={(e) => setcompanyStatusIs(e.target.value)}
            >
              <option value={""}>Select</option>
              <option value={"Active"}>Active</option>
              <option value={"Paused"}>Paused</option>
              <option value={"Inactive"}>Inactive</option>
            </select>
          </p>
        </RenderIf>
        <RenderIf isShow={!editCompanyDetails}>
          {edminDetails?.map((item: any) => (
            <div key={item?.userID}>
              <p className="sm-text">{`${item.firstName} ${item.lastName}, ${item.designation}`}</p>
              <p className="sm-text">
                <a href={`mailto:${item.email}`}>{item.email}</a> |{" "}
                <a href={`tel:+${item.PhoneCountryCode}${item.mobileNumber}`}>+{item.PhoneCountryCode} {item.mobileNumber}</a>
              </p>
              {eadminActivationLink && (
                <p className="sm-text">
                  <strong>E-Admin Activation Link:</strong><br />
                  <code style={{ wordBreak: 'break-all', display: 'block', backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '4px', marginTop: '4px' }}>
                    {eadminActivationLink}
                  </code>
                </p>
              )}
            </div>
          ))}
        </RenderIf>
        <RenderIf isShow={!!editCompanyDetails}>
          <div className="row p-2">
            <div className="col-lg-6">
              <label className="sm-text">First Name</label>
              <input
                type="text"
                className="form-control form-control-sm mb-2"
                value={eadminFirstName}
                onChange={(e) => seteadminFirstName(e.target.value)}
              />
            </div>
            <div className="col-lg-6">
              <label className="sm-text">Last Name</label>
              <input
                type="text"
                className="form-control form-control-sm mb-2"
                value={eadminLastName}
                onChange={(e) => seteadminLastName(e.target.value)}
              />
            </div>
            <div className="col-lg-6">
              <label className="sm-text">Email</label>
              <input
                type="email"
                className="form-control form-control-sm mb-2"
                value={eadminEmail}
                onChange={(e) => seteadminEmail(e.target.value)}
              />
            </div>
            <div className="col-lg-3">
              <label className="sm-text">Country Code</label>
              <input
                type="number"
                className="form-control form-control-sm mb-2"
                value={eadminPhoneCode}
                onChange={(e) => seteadminPhoneCode(Number(e.target.value))}
              />
            </div>
            <div className="col-lg-3">
              <label className="sm-text">Phone</label>
              <input
                type="tel"
                className="form-control form-control-sm mb-2"
                value={eadminPhone}
                onChange={(e) => seteadminPhone(e.target.value)}
              />
            </div>
            <div className="col-lg-6">
              <label className="sm-text">Designation</label>
              <input
                type="text"
                className="form-control form-control-sm mb-2"
                value={eadminDesignation}
                onChange={(e) => seteadminDesignation(e.target.value)}
              />
            </div>
          </div>
        </RenderIf>
        {/* <p className="sm-text">Kamal Nath, TA – Director</p>
        <p className="sm-text">
          <a href="mailto:Kamal.n@amazon.com">Kamal.n@amazon.com</a> |{" "}
          <a href="tel:+919845012345">+91 9845012345</a>
        </p> */}
        {cepDetails?.map((item: any) => (
          <div>
            <p className="sm-text">
              CEP: {`${item.firstName} ${item.lastName}`}
            </p>
          </div>
        ))}
        {/* <p className="sm-text">CEP: Maria Hill</p> */}
      </div>
      <div className="p-2"></div>
      <SectionContainer
        onShowToggle={(data: string) => setvisibleSectionIs(data)}
        visibleSection={visibleSectionIs}
        sectionTitle="Statistics"
      >
        <div className="d-flex align-items-center justify-content-between ">
          <p className="lg-text">{/* <u>Last 5 Payments:</u> */}</p>
          <button
            className="border-0 bg-white text-primary"
            onClick={() => fetchCompanyStatsDataById()}
          >
            <span className="me-2 p-1 primary-color">Refresh</span>{" "}
            <HiOutlineRefresh className={`me-2 primary-color`} />
          </button>
        </div>
        <div className="d-flex py-3 bg-light rounded mx-1 my-2">
          {/* {statsData.map((item, idx) => (
            <StatsBoxOne
              key={idx}
              label={item.label}
              numbers={item.numbers}
              desc={item.desc}
              inPercentage={item.inPercentage}
              inRupees={item.inRupees}
              className="mx-2"
            />
          ))} */}
          <StatsBoxOne
            label={"Candidates"}
            numbers={``}
            desc={``}
            presentValue={companyStatsData?.joinedCandidatesCount}
            totalValue={companyStatsData?.candidateCount}
            presentValueLabel="Active"
            totalValueLabel="All Time"
            inPercentage={false}
            inRupees={false}
            className="mx-2"
          />
          <StatsBoxOne
            label={"Effectiveness"}
            numbers={""}
            desc={""}
            presentValue={"0"}
            totalValue={"0"}
            presentValueLabel="E.Score"
            totalValueLabel="Progress"
            inPercentage={false}
            inRupees={false}
            className="mx-2"
          />
          <StatsBoxOne
            label={"CardSets"}
            numbers={companyStatsData?.cardSetsCount || 0}
            desc={""}
            inPercentage={false}
            inRupees={false}
            className="mx-2"
          />
          <StatsBoxOne
            label={"Joiners"}
            numbers={companyStatsData?.joiners || 0}
            desc={``}
            presentValue={companyStatsData?.joinedCandidatesCount}
            totalValue={companyStatsData?.candidateCount}
            presentValueLabel="Joiners"
            totalValueLabel="Out of"
            inPercentage={true}
            inRupees={false}
            className="mx-2"
          />
        </div>
      </SectionContainer>
      <SectionContainer
        onShowToggle={(data: string) => setvisibleSectionIs(data)}
        visibleSection={visibleSectionIs}
        sectionTitle="Record A Payment"
      >
        <form
          className=" w-100 py-2"
          onSubmit={handleSubmit((data) => {
            createPayment(data);
          })}
        >
          <div className="row  p-0 m-0">
            <div className="col-lg-4">
              <TextInputLayout
                isError={errors.amountIs?.message}
                label={"Amount"}
              >
                <input
                  className={``}
                  type="tel"
                  autoComplete="off"
                  {...register("amountIs", {
                    required: " Please enter amount",
                  })}
                />
              </TextInputLayout>
            </div>
            <div className="col-lg-4 m-0 p-0">
              <p className="sm-text">Payment Received on</p>
              <TextInputLayout isError={errors.dojYY?.message}>
                <input
                  className="w-100"
                  type="date"
                  placeholder="Select a date"
                  max={dayjs().format("YYYY-MM-DD")}
                  {...register("dojYY", {
                    required: "DOJ required",
                  })}
                />
              </TextInputLayout>
            </div>
            {/* <div className="col-lg-9 m-0 p-0">
              <div className="row m-0 d-flex align-items-end p-0">
                <p className="sm-text">Payment Received on</p>
                <div className="col-lg-4">
                  <TextInputLayout isError={errors.dojYY?.message}>
                    <select
                      className={`flex-grow-1 border-0`}
                      id="dojYY"
                      {...register("dojYY", {
                        required: "dojYY required",
                      })}
                    >
                      <option value={""}>YY</option>
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </TextInputLayout>
                </div>
                <div className="col-lg-4">
                  <TextInputLayout isError={errors.dojMM?.message} label={""}>
                    <select
                      className={`flex-grow-1 border-0`}
                      id="dojMM"
                      {...register("dojMM", {
                        required: "dojMM required",
                      })}
                    >
                      <option value={""}>MM</option>
                      {months.map((month) => (
                        <option key={month} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </TextInputLayout>
                </div>
                <div className="col-lg-4">
                  <TextInputLayout isError={errors.dojDD?.message}>
                    <select
                      className={`flex-grow-1 border-0`}
                      id="dojDD"
                      {...register("dojDD", {
                        required: "dojDD required",
                      })}
                    >
                      <option value={""}>DD</option>
                      {days.map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                    </select>
                  </TextInputLayout>
                </div>
              </div>
            </div> */}

            <div className="col-lg-8">
              <TextInputLayout
                isError={errors.txnDetailsIs?.message}
                label={"Txn Details"}
              >
                <input
                  className={`flex-grow-1`}
                  autoComplete="off"
                  {...register("txnDetailsIs", {
                    required: " Please enter txn details",
                  })}
                />
              </TextInputLayout>
            </div>
            <div className=" col-lg-3 col-md-4 d-flex flex-column justify-content-end p-2">
              <button type="submit" className="btn primary-bg text-white w-100">
                Submit
              </button>
            </div>
          </div>

          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {/* <div className="row border">
            <div className="col-lg-8 border">
              <div className="container">
                <div className="row">
                  <p className="sm-text">Payment Received on</p>
                  <div className="col-sm-4 border">
                    <TextInputLayout isError={errors.dojYY?.message}>
                      <select
                        className={`flex-grow-1 border-0`}
                        id="dojYY"
                        {...register("dojYY", {
                          required: "dojYY required",
                        })}
                      >
                        <option value={""}>YY</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </TextInputLayout>
                  </div>
                  <div className="col-sm-4 border">
                    <TextInputLayout isError={errors.dojMM?.message}>
                      <select
                        className={` border-0`}
                        id="dojMM"
                        {...register("dojMM", {
                          required: "dojMM required",
                        })}
                      >
                        <option value={""}>MM</option>
                        {months.map((month) => (
                          <option key={month} value={month}>
                            {month}
                          </option>
                        ))}
                      </select>
                    </TextInputLayout>
                  </div>
                  <div className="col-sm-4 border">
                    <TextInputLayout isError={errors.dojDD?.message}>
                      <select
                        className={` border-0`}
                        id="dojDD"
                        {...register("dojDD", {
                          required: "dojDD required",
                        })}
                      >
                        <option value={""}>DD</option>
                        {days.map((day) => (
                          <option key={day} value={day}>
                            {day}
                          </option>
                        ))}
                      </select>
                    </TextInputLayout>
                  </div>
                </div>
              </div>
            </div>

           

            <div className="row">
              <p className="sm-text">Payment Received on</p>
              <div className="col-sm-4">
                <TextInputLayout isError={errors.dojYY?.message}>
                  <select
                    className={`flex-grow-1 border-0`}
                    id="dojYY"
                    {...register("dojYY", {
                      required: "dojYY required",
                    })}
                  >
                    <option value={""}>YY</option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </TextInputLayout>
              </div>
              <div className="col-sm-4">
                <TextInputLayout isError={errors.dojMM?.message}>
                  <select
                    className={`flex-grow-1 border-0`}
                    id="dojMM"
                    {...register("dojMM", {
                      required: "dojMM required",
                    })}
                  >
                    <option value={""}>MM</option>
                    {months.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </TextInputLayout>
              </div>
              <div className="col-sm-4">
                <TextInputLayout isError={errors.dojDD?.message}>
                  <select
                    className={`flex-grow-1 border-0`}
                    id="dojDD"
                    {...register("dojDD", {
                      required: "dojDD required",
                    })}
                  >
                    <option value={""}>DD</option>
                    {days.map((day) => (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    ))}
                  </select>
                </TextInputLayout>
              </div>
            </div>
            <p></p>
            <div className="d-flex justify-content-center ">
              <button
                type="submit"
                className="btn btn-primary w-25 h-75 sm-text"
              >
                Submit
              </button>
            </div>
          </div> */}
        </form>
      </SectionContainer>
      <SectionContainer
        onShowToggle={(data: string) => setvisibleSectionIs(data)}
        visibleSection={visibleSectionIs}
        sectionTitle="Subscription"
      >
        <div className="p-2">
          <div className="d-flex align-items-start justify-content-between ">
            {subscriptionDetails.map((item: any) => (
              <div
                className={`d-flex flex-column p-2  flex-grow-1 h-100 `}
                style={{ flexGrow: 1 }}
              >
                <div className={`mb-1`}>
                  <p className={`x-sm-text`}>Plan:</p>
                  <RenderIf isShow={!editSubscriptionPlans}>
                    <p className={`md-text text-primary my-1`}>
                      {item?.subscriptionName}
                    </p>
                  </RenderIf>
                  <RenderIf isShow={!!editSubscriptionPlans}>
                    <TextInputLayout className="w-50">
                      <select
                        value={planNameIs}
                        className="border-0 w-100 px-1"
                        // onChange={(e) => setplanNameIs(Number(e.target.value))}
                        onChange={async (e) => {
                          const selectedPlanID = Number(e.target.value);
                          // setplanNameIs(selectedPlanID);

                          const selectedPlan = _planList.find(
                            (plan) => plan.subscriptionID === selectedPlanID
                          );
                          if (selectedPlan) {
                            setplanNameIs(selectedPlan?.subscriptionID);
                            setselectedPlanDetails(selectedPlan);
                            // setplanValidity(selectedPlan?.subscriptionDuration);
                          }
                        }}
                      >
                        {_planList?.map((item: any) => (
                          <option
                            key={item.subscriptionID}
                            value={item.subscriptionID}
                          >
                            {item.subscriptionName}
                          </option>
                        ))}
                      </select>
                    </TextInputLayout>
                  </RenderIf>
                </div>
                <div className={`mb-1`}>
                  <p className={`x-sm-text`}>Frequency:</p>
                  <RenderIf isShow={true}>
                    <p className={`md-text text-primary my-1`}>
                      Monthly / Quarterly
                    </p>
                  </RenderIf>
                  <RenderIf isShow={false}>
                    <TextInputLayout className="w-50">
                      <select
                        value={planFrequency}
                        className="border-0 w-100 px-1"
                        disabled
                        onChange={(e) => setplanFrequency(e.target.value)}
                      >
                        <option value={""}>Select</option>
                        <option value={"Monthly"}>Monthly</option>
                        <option value={"Quarterly"}>Quarterly</option>
                        <option value={"Yearly"}>Yearly</option>
                      </select>
                    </TextInputLayout>
                  </RenderIf>
                </div>
                <div className={`mb-1`}>
                  <p className={`x-sm-text`}>Cost:</p>
                  <RenderIf isShow={!editSubscriptionPlans}>
                    <p className={`md-text text-primary my-1`}>
                      ₹{Number(item.subscriptionFees).formatRupee()} per month
                    </p>
                  </RenderIf>
                  <RenderIf isShow={!!editSubscriptionPlans}>
                    {/* <TextInputLayout className="w-50">
                      <input
                        value={planCost}
                        disabled
                        placeholder="Enter amount per moth"
                        onChange={(e) => setplanCost(e.target.value)}
                      />
                    </TextInputLayout> */}
                    <p className={`md-text text-primary my-1`}>
                      ₹
                      {selectedPlanDetails.subscriptionFees === 0
                        ? item.subscriptionFees
                        : selectedPlanDetails.subscriptionFees}{" "}
                      per month
                    </p>
                  </RenderIf>
                </div>
                <div className={`mb-0`}>
                  <p className={`x-sm-text`}> Valid Till:</p>
                  <RenderIf isShow={!editSubscriptionPlans}>
                    <p className={`md-text text-primary mt-1`}>
                      {!dayjs(companyDetails.subscriptionValidUpto).isValid()
                        ? "NA"
                        : dayjs(_subscriptionValidUpto).format("MMM DD, YYYY")}
                    </p>
                  </RenderIf>
                  <RenderIf isShow={!!editSubscriptionPlans}>
                    <TextInputLayout className="w-50">
                      <input
                        value={
                          planValidity
                            ? dayjs(planValidity).format("YYYY-MM-DD")
                            : dayjs(
                              companyDetails.subscriptionValidUpto
                            ).format("YYYY-MM-DD")
                        }
                        // value={new Date(planValidity).toDateString()}
                        className="border-0 w-100"
                        type="date"
                        placeholder="Select a date"
                        min={dayjs().add(1, "day").format("YYYY-MM-DD")}
                        onChange={(e) => setplanValidity(e.target.value)}
                      />
                    </TextInputLayout>
                  </RenderIf>
                </div>
              </div>
            ))}
            <RenderIf
              isShow={!editSubscriptionPlans && subscriptionDetails?.length > 0}
            >
              <button
                className="border-0 bg-white text-primary"
                onClick={() => seteditSubscriptionPlans(true)}
              >
                <MdOutlineModeEditOutline className={`me-2 primary-color`} />
                <span className="me-2 p-1 primary-color">Edit</span>{" "}
              </button>
            </RenderIf>
            <RenderIf isShow={!!editSubscriptionPlans}>
              {/* <button
                className="border border-primary rounded bg-white text-primary "
                onClick={() => updateSubscriptionPlans()}
              >
                <span className="me-2 p-1">Update</span>{" "}
              </button> */}
              <div className=" col-lg-2 col-md-4 d-flex flex-column justify-content-end p-2">
                <button
                  type="submit"
                  onClick={() => updateSubscriptionPlans()}
                  className="btn btn-sm primary-bg text-white w-100"
                >
                  Update
                </button>
              </div>
            </RenderIf>
            <RenderIf isShow={!!editSubscriptionPlans}>
              {/* <button
                className="secondary-border ms-2 secondary-color rounded bg-white "
                onClick={() => seteditSubscriptionPlans(false)}
              >
                <span className="me-2 p-1">Cancel</span>{" "}
              </button> */}
              <div className=" col-lg-2 col-md-4 d-flex flex-column justify-content-end p-2">
                <button
                  type="submit"
                  onClick={() => seteditSubscriptionPlans(false)}
                  className="btn btn-sm primary-bg text-white w-100"
                >
                  Cancel
                </button>
              </div>
            </RenderIf>
          </div>
          <RenderIf isShow={subscriptionDetails?.length < 1}>
            <div className="w-100 d-flex align-items-center justify-content-center">
              <p className="text-secondary m-3">-: No Data :-</p>
            </div>
          </RenderIf>
        </div>
      </SectionContainer>
      <SectionContainer
        onShowToggle={(data: string, isSectionOpening: boolean) => {
          setvisibleSectionIs(data);
          if (isSectionOpening) {
            getPayments();
          }
        }}
        visibleSection={visibleSectionIs}
        sectionTitle="Last 5 Payments"
      >
        <div className="col-lg-12 p-2 ps-4">
          <div className="d-flex align-items-center justify-content-between ">
            <p className="lg-text">{/* <u>Last 5 Payments:</u> */}</p>
            <button
              className="border-0 bg-white text-primary"
              onClick={() => getPayments()}
            >
              <span className="me-2 p-1 primary-color">Refresh</span>{" "}
              <HiOutlineRefresh className={`me-2 primary-color`} />
            </button>
          </div>
          <p></p>
          {/* <p className="sm-text">
              <strong>₹ 5,000</strong> | 5:20 PM on Dec 1, 2023
            </p>
            <p className="sm-text">
              <strong>₹ 5,000</strong> | 8:00 AM on Nov 3, 2023
            </p>
            <p className="sm-text">
              <strong>₹ 5,000</strong> | 5:20 PM on Oct 1, 2023
            </p>
            <p className="sm-text">
              <strong>₹ 5,000</strong> | 12:00 PM on Sep 1, 2023
            </p>
            <p className="sm-text">
              <strong>₹ 5,000</strong> | 5:20 PM on Aug 1, 2023
            </p> */}
          <RenderIf isShow={paymentDetails?.length > 0}>
            {/* {paymentDetails.map((item: any) => (
              <p className="sm-text">
                <strong>₹ {item.amount}</strong> |{" "}
                {dayjs(item.receivedDate).format("MMM DD, YYYY")}
              </p>
            ))} */}
            <LastFivePaymentTable tableData={paymentDetails} />
          </RenderIf>
          <RenderIf isShow={paymentDetails?.length < 1}>
            <div className="w-100 d-flex align-items-center justify-content-center">
              <p className="text-secondary m-3">-: No Data :-</p>
            </div>
          </RenderIf>
        </div>
      </SectionContainer>
      <SectionContainer
        onShowToggle={(data: string) => setvisibleSectionIs(data)}
        visibleSection={visibleSectionIs}
        sectionTitle="Monthly Usage Details"
      >
        <div>
          <MonthlyDetailsTable dataIs={companyStatsData?.companyStats} />
        </div>
      </SectionContainer>
    </ComapnyDetailsWarpper>
  );
};
export default React.memo(ComapnyDetails);
const ComapnyDetailsWarpper = styled.div`
  /* border: 1px solid blue; */
  /* display: flex;
  flex-direction: column;
  flex: 1;
  flex-grow: 1; */
  height: 100%;
  /* overflow: auto; */
  overflow: hidden;
  overflow-y: auto;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  .logo_box {
    height: 70px;
  }
`;

const TopBar = styled.div``;
